import React from 'react';
import { SelectInput } from 'react-admin';
import { Role } from './types';

export const RoleInput = (props: any) => (<SelectInput
    {...props}
    choices={[0,1,2].map((idx) => ({ id: idx, name: Role[idx] }))}
  />
);
